import React, { useState } from "react"
import { Container, Row, Col } from "reactstrap"
import TaskList from "../../../../../TaskManagement/TaskList"
import TaskManagementListHeader from "../../../../../TaskManagement/TaskManagementListHeader"

const DriverTasksTab = ({ driverId }) => {
    const [orderBy] = useState(['-date_added'])
    const [filterValues, setFilterValues] = useState({ searchTerm: '', driverId: driverId, isArchived: false })

    return (
        <Container fluid className="driver-tasks-tab">
            <div className="info-container mt-0">
                <TaskManagementListHeader
                    activeTab="all"
                    filterValues={filterValues}
                    setFilterValues={(res) => setFilterValues({ ...res, driverId: driverId })}
                />
                <Row>
                    <Col className="TaskListColumn">
                        <TaskList {...filterValues} orderBy={orderBy} />
                    </Col>
                </Row>
            </div>
        </Container>
    )
}

export default DriverTasksTab
